<template>
  <div>
    <topbar
      :titulo="$t('CONTABIL.LANCAMENTOS_CONTABEIS')"
      :subtitulo="$t('CONTABIL.LANCAMENTOS_CONTABEIS_DESCRICAO_PAGE')"
      :breadcrumbs="breadcrumbs"
    >
      <template #header>
        <div
          class="d-flex flex-md-row flex-column justify-content-between ml-md-4"
        >
          <b-button
            variant="info"
            @click="abrirModalLancamentosContabil"
            v-if="podeCadastrar"
          >
            {{ $t('GERAL.CADASTRAR') }}
          </b-button>
        </div>
      </template>
    </topbar>

    <b-row id="Filtro">
      <b-col md="4">
        <input-text
          ref="documento"
          v-model="filtrandoPor"
          :label="$t('GERAL.DOCUMENTO')"
          :placeholder="$t('GERAL.DOCUMENTO')"
          @enter="getFiltro"
        />
      </b-col>
      <b-col md="auto" class="d-flex align-items-center mb-3">
        <b-form-checkbox v-model="somenteDesbalanceados" switch @change="buscaDados">
          {{ $t('CONTABIL_LANCAMENTO.SOMENTE_DESBALANCEADOS') }}
        </b-form-checkbox>
      </b-col>
      <b-col md="auto">
        <b-button
          variant="primary"
          class="botao-acao-filtro mb-3 w-100"
          @click="buscaDados"
        >
          {{ $t('GERAL.FILTRAR') }}
        </b-button>
      </b-col>
      <b-col md="auto">
        <b-button
          variant="secondary"
          class="botao-acao-filtro mb-3 w-100"
          @click="limparFiltro"
        >
          {{ $t('GERAL.LIMPAR') }}
        </b-button>
      </b-col>
    </b-row>

    <b-table
      :fields="fields"
      :items="items"
      :empty-text="$t('GERAL.NENHUM_REGISTRO')"
      head-variant="light"
      stacked="md"
      show-empty
      responsive
      striped
      hover
      no-local-sorting
      @sort-changed="aoMudarOrdenacao"
    >
      <template #cell(codigo)="{ item }">
        {{ item.codigo }}
        <b-badge v-if="item.desbalanceado" variant="danger" class="ml-1">
          {{ $t('CONTABIL_LANCAMENTO.DESBALANCEADO') }}
        </b-badge>
      </template>
      <template #cell(acoes)="item">
        <b-dropdown variant="outline-default" v-if="podeEditar || podeExcluir">
          <b-dropdown-item
            @click="abrirLancamentoContabil(item)"
            v-if="podeEditar"
          >
            {{ $t('GERAL.EDITAR') }}
          </b-dropdown-item>
          <b-dropdown-item
            @click="confirmarExclusao(item.item)"
            v-if="podeExcluir"
          >
            {{ $t('GERAL.EXCLUIR') }}
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </b-table>

    <paginacao
      v-model="paginacao"
      :total="paginacao.total"
      @input="getDocumentoContabil"
    />

    <modal-lancamentos-contabeis
      ref="refModalLancamentosContabeis"
      :form="modais.lancamentoContabilDados"
      @fechar="closeModal"
      @atualizarTabela="getDocumentoContabil"
    />
  </div>
</template>
<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
// Services:
import DocumentoContabil from '@/common/services/lancamento-contabil/lancamento-contabil.service';

//Components:
import ModalLancamentosContabeis from './components/modal/Index';
import Paginacao from '@/components/paginacao/Paginacao';
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';
import Permissoes from '@/components/mixins/permissoes';
import { InputText } from '@/components/inputs';
import helpers from '@/common/utils/helpers';

export default {
  mixins: [Permissoes],
  components: {
    InputText,
    Topbar,
    Paginacao,
    ModalLancamentosContabeis,
  },
  data() {
    return {
      items: [],
      fields: [
        {
          key: 'codigo',
          label: this.$t('CONTABIL.DOCUMENTO'),
          sortable: true,
        },
        {
          key: 'dataMovimento',
          label: this.$t('CONTABIL.DATA_MOVIMENTO'),
          formatter: (value) => {
            return value ? helpers.formatarDataBr(value) : '-';
          },
          sortable: true,
        },
        {
          key: 'dataDocumento',
          label: this.$t('CONTABIL.DATA_DOCUMENTO'),
          formatter: (value) => {
            return value ? helpers.formatarDataBr(value) : '-';
          },
          sortable: true,
        },
        {
          key: 'valor',
          label: this.$t('CONTABIL.VALOR_BRL'),
          formatter: (value) => {
            return value ? helpers.formatacaoMoedaBRL(value) : '-';
          },
          sortable: true,
        },
        {
          key: 'objetoReferenciaId',
          label: this.$t('CONTABIL.OBJETO_REFERENCIA'),
          sortable: true,
        },
        {
          key: 'acoes',
          label: this.$t('CONTABIL.ACOES'),
        },
      ],
      breadcrumbs: [
        { titulo: this.$t('CONTABIL.CONTABIL') },
        { titulo: this.$t('CONTABIL.PERIODOS_CONTABEIS') },
      ],
      modais: {
        lancamentoContabil: false,
      },
      filtrandoPor: '',
      somenteDesbalanceados: false,
      paginacao: { numeroDaPagina: 1, tamanhoDaPagina: 10, total: 0 },
      campoOrdenado: null,
      ordem: false,
    };
  },
  mounted() {
    this.getDocumentoContabil();
  },
  methods: {
    aoMudarOrdenacao({ sortBy, sortDesc }) {
      this.campoOrdenado = helpers.primeiraLetraMaiuscula(sortBy);
      this.ordem = sortDesc;
      this.getDocumentoContabil();
    },
    abrirModalLancamentosContabil(item) {
      this.$refs.refModalLancamentosContabeis.abrirModal(item);
    },
    abrirLancamentoContabil({ item }) {
      this.$router.push(`/contabil/lancamentos/${item.id}`);
    },
    closeModal() {
      return (this.modais.lancamentoContabil = false);
    },
    buscaDados() {
      this.paginacao.numeroDaPagina = 1;
      this.getDocumentoContabil(this.filtrandoPor);
    },
    getDocumentoContabil(filtro) {
      this.filtrandoPor = filtro === '' ? filtro : this.filtrandoPor;

      let param = {
        NumeroDaPagina: this.paginacao.numeroDaPagina,
        TamanhoDaPagina: this.paginacao.tamanhoDaPagina,
        CampoOrdenado: this.campoOrdenado,
        OrdenacaoAscendente: this.ordem,
        Documento: this.filtrandoPor,
        SomenteDesbalanceados: this.somenteDesbalanceados,
      };

      this.$store.dispatch(START_LOADING);
      DocumentoContabil.obterPor(param)
        .then(({ data }) => {
          this.items = data.itens;
          this.paginacao.total = data.paginacao.totalDeElementos;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    async confirmarExclusao(item) {
      const respostaExclusao = await mensagem.confirmacao(
        this.$t('CONTABIL_LANCAMENTO.CONFIRMAR_EXCLUIR_DOCUMENTO'),
        this.$t('CONTABIL_LANCAMENTO.CONFIRMAR_EXCLUIR_DOCUMENTO_MENSAGEM')
      );
      if (respostaExclusao.isConfirmed) {
        this.excluir(item);
      }
    },

    excluir(item) {
      this.$store.dispatch(START_LOADING);
      DocumentoContabil.excluir(item.id)
        .then(({ data }) => {
          mensagem.sucesso(this.$t('GERAL.SUCESSO'), data.mensagem);
          this.getDocumentoContabil();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    limparFiltro() {
      this.filtrandoPor = '';
      this.somenteDesbalanceados = false;
      this.paginacao.numeroDaPagina = 1;
      this.getFiltro();
    },
    getFiltro() {
      this.getDocumentoContabil();
    },
    novaOrdenacao(campoOrdenado, ordem) {
      this.campoOrdenado = campoOrdenado;
      this.ordem = !ordem;
      this.getDocumentoContabil();
    },
  },
};
</script>
